import { useEffect } from 'react';

import { useAuthQuery } from '../../../auth/hooks/useAuthQuery';
import { useFlags } from '../../../contexts/LDContext';

import { hideZendeskWidget, showZendeskWidget, startChat } from './Chat.service';

export const useChat = () => {
  const { user, userIdentity } = useAuthQuery();
  const { enableZendeskChat } = useFlags();

  useEffect(() => {
    // Wait for userIdentity to ensure CSRF token is available for POST requests
    if (user && userIdentity) {
      startChat(user.email, enableZendeskChat);
    }
  }, [user, userIdentity, enableZendeskChat]);

  // Show/hide Zendesk widget based on feature flag and login state
  useEffect(() => {
    if (user && enableZendeskChat) {
      showZendeskWidget();
    } else {
      hideZendeskWidget();
    }
  }, [user, enableZendeskChat]);
};
